'use client';

import React, { useEffect, useMemo } from 'react';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import useUserSettings from 'src/hooks/users/useUserSettings';
import { USER_SETTINGS } from 'src/hooks/users/constants';
import { useSavedVolume } from 'src/hooks/savedVolume/useSavedVolume';
import { LOCATION } from 'src/hooks/filters/constants';
import { useGetFilterSetsQuery } from 'src/api/redux/filterSets';

const ResultsHeader: React.FC = (): React.ReactElement => {
  useDrawer();
  const { settings, setSetting } = useUserSettings();
  const { appliedSavedVolume } = useSavedVolume(LOCATION.DISCOVERY);

  // Use RTK Query directly for code sets data
  const { data: filterSetsData } = useGetFilterSetsQuery({ q: '', serializer: 'detailed' });
  // allCodeSets is needed to find the current code set for UI display
  const _allCodeSets = useMemo(() => {
    return filterSetsData?.results?.filter((set) => set.type === 'CODE') || [];
  }, [filterSetsData]);

  // Reserved for future use to display the current code set
  void _allCodeSets;
  void appliedSavedVolume;

  useEffect(() => {
    if (
      settings?.prospectType === 'C' &&
      settings?.prospectMode === 'sending'
    ) {
      setSetting(USER_SETTINGS.PROSPECT_MODE, 'treating');
    }
  }, [settings?.prospectType, setSetting, settings?.prospectMode]);

  return null;
};

export default ResultsHeader;
